import { render, staticRenderFns } from "./addLabel.vue?vue&type=template&id=c2b58302&scoped=true&"
import script from "./addLabel.vue?vue&type=script&lang=js&"
export * from "./addLabel.vue?vue&type=script&lang=js&"
import style0 from "./addLabel.vue?vue&type=style&index=0&id=c2b58302&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b58302",
  null
  
)

export default component.exports